import type { FlagsMapper } from '@atlassian/jira-flags';
import {
	ADD_CATEGORIES_FOR_ARTICLE_FAILURE,
	type AddCategoriesForArticleFailureAction,
} from '../state/actions/add-categories-for-article-failure';
import {
	REMOVE_LABEL_FROM_ARTICLE_FAILURE,
	type RemoveLabelFromArticleFailureAction,
} from '../state/actions/remove-label-from-article-failure';
import {
	type UpdateCategoriesForArticleFailureAction,
	UPDATE_CATEGORIES_FOR_ARTICLE_FAILURE,
} from '../state/actions/update-categories-for-article-failure';
import removeLabelFromArticleFailureFlag from './remove-label-from-article-failure';
import updateCategoriesForArticleFailureFlag from './update-categories-for-article-failure';

type Action =
	| AddCategoriesForArticleFailureAction
	| UpdateCategoriesForArticleFailureAction
	| RemoveLabelFromArticleFailureAction;

const flagsMapper: FlagsMapper<Action, undefined> = (action) => {
	switch (action.type) {
		case UPDATE_CATEGORIES_FOR_ARTICLE_FAILURE:
		case ADD_CATEGORIES_FOR_ARTICLE_FAILURE: {
			return updateCategoriesForArticleFailureFlag();
		}
		case REMOVE_LABEL_FROM_ARTICLE_FAILURE: {
			return removeLabelFromArticleFailureFlag();
		}

		default:
			return undefined;
	}
};

export default flagsMapper;
